/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnswerOptionView } from './answerOptionView';


/**
 * Вопрос с ответом и ID предыдущего и последующего вопросов.
 */
export interface QuestionInRow { 
    /**
     * ID фотографии вопроса.
     */
    photoId?: string;
    /**
     * 
     */
    answerTypeId?: number;
    /**
     * 
     */
    sortOrder?: number;
    /**
     * Идентификатор вопроса.
     */
    id?: string;
    /**
     * Идентификатор опроса.
     */
    pollId?: string;
    /**
     * Вопрос.
     */
    text?: string;
    /**
     * Список вариантов ответов.
     */
    answers?: Array<AnswerOptionView>;
    /**
     * ID предыдущего вопроса.
     */
    previousQuestionId?: string;
    /**
     * ID последующего вопроса.
     */
    nextQuestionId?: string;
}

